export const readingsForDisplay = [
  {
    label: "Blood Pressure",
    readingKey: "bp",
    subTypes: [
      { key: "systolic", label: "Systolic" },
      { key: "diastolic", label: "Diastolic" }
    ]
  },
  {
    label: "Blood Glucose",
    readingKey: "bgl",
    subTypes: [
      { key: "glucose", label: "Glucose" }
    ]
  },
  {
    label: "Spirometry",
    readingKey: "spir",
    subTypes: [
      { key: "FEV1", label: "FEV1" },
      { key: "FVC", label: "FVC" },
      { key: "FEV1_FVC", label: "FEV1/FVC" },
      { key: "PEF", label: "PEF"}
    ]
  },
  {
    label: "Oxygen Saturation",
    readingKey: "spo2",
    subTypes: [
      { key: "spo2", label: "Oxygen Saturation" }
    ]
  },
  {
    label: "Heart Rate",
    readingKey: "hrt",
    subTypes: [
      { key: "pulse", label: "Pulse" }
    ]
  },
  {
    label: "Temperature",
    readingKey: "temp",
    subTypes: [
      { key: "temp", label: "Temperature"}
    ]
  },
  {
    label: "Weight",
    readingKey: "wt",
    subTypes: [
      { key: "wt", label: "Weight" }
    ]
  },
  {
    label: "Activity",
    readingKey: "activity",
    subTypes: [
      { key: "steps", label: "Activity" }
    ]
  },
  {
    label: "Sleep",
    readingKey: "sleep",
    subTypes: [
      { key: "sleep", label: "Sleep" }
    ]
  },
];

export const getUnitsFor = (subType: string) => {
  const unitsMap: Record<string, string> = {
    systolic: "mmHg",
    diastolic: "mmHg",
    glucose: "mg/dL",
    FEV1: "L",
    FVC: "L",
    FEV1_FVC: "%",
    PEF: "L/s",
    spo2: "%",
    pulse: "bpm",
    temp: "°F",
    wt: "lbs",
    steps: "steps",
    sleep: "hrs",
  };
  return unitsMap[subType] || "";
};

export const normalizeThresholds = (rawThresholds: any[]) => {
  const map: Record<string, any> = {
    moderate: {},
    high: {}
  };

  rawThresholds.forEach(threshold => {
    const alertLevel = threshold.breachType;

    for (const subType in threshold.value) {
      const thresholdValue = threshold.value[subType];

      map[alertLevel][subType] = {
        low: thresholdValue.low ?? null,
        high: thresholdValue.high ?? null,
        units: thresholdValue.units
      };
    }
  });

  return map;
};

export function validateCheckedThresholds(
  threshold: any,
  readings: typeof readingsForDisplay,
  lowCheckedMap: Record<string, boolean>,
  highCheckedMap: Record<string, boolean>
): boolean {
  for (const reading of readings) {
    for (const subType of reading.subTypes) {
      const key = subType.key;
      if (lowCheckedMap[key]) {
        const modThresh = threshold.moderate[key as keyof typeof threshold.moderate];
        if (!modThresh?.low || !modThresh?.high || modThresh.low === 0 || modThresh.high === 0) {
          return false;
        }
      }
      if (highCheckedMap[key]) {
        const highThresh = threshold.high[key as keyof typeof threshold.high];
        if (!highThresh?.low || !highThresh?.high || highThresh.low === 0 || highThresh.high === 0) {
          return false;
        }
      }
    }
  }

  return true;
}